<style  scoped>



</style>

<template>

<div class="c-loader-intro u-fixed u-pos-tl u-viewport-fit-h u-bg--brand-dark u-fit-w">
    <div class="c-loader-intro__bar c-loader-intro__bar--x u-absolute u-pos-tl u-fit-w" :style="stylesComputed"></div>
    <div class="c-loader-intro__bar c-loader-intro__bar--y u-absolute u-pos-tr u-fit-h" :style="stylesComputed2"></div>
    <div class="c-loader-intro__bar c-loader-intro__bar--x u-absolute u-pos-bl u-fit-w" :style="stylesComputed"></div>
    <div class="c-loader-intro__bar c-loader-intro__bar--y u-absolute u-pos-tl u-fit-h" :style="stylesComputed2"></div>
    <div class="c-loader-intro__logo u-absolute u-pos-center u-force-inline">

        <div class="c-loader-intro__ribbon-container o-wrapper--panel u-fit">
            <!--<img src="../../assets/medias/images/logo-white-trigercontracting.png" class="c-loader-intro__logo__typo u-absolute">-->
          <img src="../../assets/medias/images/logo-white-trigercontracting.png" class="c-loader-intro__logo__ribbon__AV">

        </div>
    </div>
</div>

</template>

<script>

export default {
    name: "",
    props: {
      debug: {
          type: Boolean,
          default: !1
      },
        assets: {
            type: Array,
            default: function() {}
        }
    },
    data: function() {
        return {
            percentAssetsLoaded: 0,
            minLoop: 0,
            isAssetsLoaded: !1


        }
    },
    computed: {
        stylesComputed: function() {


            return {
                transform: 'scaleY(' + (1 - this.percentAssetsLoaded) + ') translateZ(0)'

            };
        },
        stylesComputed2: function() {


            return {
                transform: 'scaleX(' + (1 - this.percentAssetsLoaded) + ') translateZ(0)'

            };
        },
        stylesHeight1: function() {
            return {
              height:this.navOffsetTop+"px"

            };
        },
        stylesHeight2: function() {
            return {
                height:$root.winHeight/(12-25)+"px"

            };
        },
        stylesHeight3Bottom: function() {
            return {
                height:$root.winHeight/(12-25)+"px",
                bottom:$root.winHeight/(12+70)+"px"

            };
        }
    },
    created: function() {
        this._nbAssetsToLoad = 0,
            this._loaderIndex = 0,
            this.eventHub.$on("loader:progress", this.onLoaderProgress),
            this.eventHub.$on("loader:start", this.onLoaderStart)
    },
    mounted: function() {
        var t = this;
        this.$el.classList.add("is-assets-loading"),
            setTimeout(function() {
                t.onTransitionLoop()
            }, 10)
    },
    destroyed: function() {
        this.eventHub.$off("loader:progress", this.onLoaderProgress),
            this.eventHub.$off("loader:start", this.onLoaderStart)
    },
    methods:
    {
        onLoaderStart: function(t)
        {
            this.debug&&console.log("OnLoadPreogress: app-loader -intro- onLoaderStart" + t);
            this._nbAssetsToLoad += t
        },
        onLoaderProgress: function()
        {
            this.debug&&console.log("OnLoadPreogress: app-loader -intro" + this._loaderIndex);
            this._loaderIndex += 1,
                this.percentAssetsLoaded = this._loaderIndex / this._nbAssetsToLoad,
                1 === this.percentAssetsLoaded && (this.isAssetsLoaded = !0)
        },
        onTransitionLoop: function() {
            var t = this;
            clearTimeout(e, n), this._loopIndex += 1;
            this.$el.classList.add("is-loop");
            var e = setTimeout(function() {
                    t.$el.classList.remove("is-loop")
                }, 1500),
                /*n = setTimeout(function() {

                    !t.isAssetsLoaded || t._loopIndex < t.minLoop ? t.onTransitionLoop() : (t.$el.classList.add("is-assets-loaded"), t.eventHub.$emit("assets:loaded"))
                }, 2700)*/
                n = setTimeout(function() {

                    !t.isAssetsLoaded || t._loopIndex < t.minLoop ? t.onTransitionLoop() : (t.eventHub.$emit("assets:loaded"))
                }, 2700)
        }
    }


}

</script>
